import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

import {
  hostInfoFormDefaultValues,
  hostPayFormDefaultValues,
  termsFormDefaultValues,
  THostInfoForm,
  THostPayForm,
  TTermsForm,
} from './sign-up-form'

export type THostInfoFormWithCertNum = THostInfoForm & { certNum?: string }

type SignUpHostStore = {
  terms: TTermsForm
  info: THostInfoFormWithCertNum
  pay: THostPayForm
  actions: {
    updateTerms: (data: TTermsForm) => void
    updateInfo: (data: THostInfoFormWithCertNum) => void
    updatePay: (data: THostPayForm) => void
    reset: () => void
  }
}
const initialState = {
  terms: termsFormDefaultValues,
  info: hostInfoFormDefaultValues,
  pay: hostPayFormDefaultValues,
}

export const useSignUpHostStore = create<SignUpHostStore>()(
  subscribeWithSelector(set => ({
    ...initialState,
    actions: {
      updateTerms: data => {
        set(state => ({
          terms: { ...state.terms, ...data },
        }))
      },
      updateInfo: data => {
        set(state => ({
          info: { ...state.info, ...data },
        }))
      },
      updatePay: data => {
        set(state => ({
          pay: { ...state.pay, ...data },
        }))
      },
      reset: () => {
        set(initialState)
      },
    },
  })),
)
